import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../services/api"; // your axios call
import "./LoginPage.css";

const LoginPage = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [lockTime, setLockTime] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (lockTime > 0) {
      const timer = setInterval(() => {
        setLockTime((prev) => (prev > 1 ? prev - 1 : 0));
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [lockTime]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (lockTime > 0) return; // prevent spam login while locked

    setLoading(true);
    setErrorMsg("");

    try {
      const res = await loginUser(phoneNumber, password);
      const data = res.data;

      // ✅ Only allow admin role
      const role = data.role?.trim().toUpperCase();
      if (role !== "ROLE_ADMIN") {
        setErrorMsg("Incorrect ID or password");
        return;
      }

      // ✅ Store only for admin
      localStorage.setItem("token", data.token);
      localStorage.setItem("role", data.role);
      localStorage.setItem("flatNumber", data.flatNumber);

      navigate("/admin");
    } catch (error) {
      console.error(error);
      const msg =
        error.response?.data?.message ||
        error.message ||
        "Incorrect ID or password";

      if (msg.includes("locked")) {
        // Extract minutes from backend message like “Try again after 5 minutes”
        const minutesMatch = msg.match(/(\d+)\s*minutes?/i);
        const minutes = minutesMatch ? parseInt(minutesMatch[1]) : 5;
        setLockTime(minutes * 60);
      }

      setErrorMsg("Incorrect ID or password");
    } finally {
      setLoading(false);
    }
  };

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  return (
    <div className="login-wrapper">
      <div className="login-bg">
        <div className="circle circle1"></div>
        <div className="circle circle2"></div>
      </div>

      <div className="login-box">
        <h2>Smart Gate Admin Login</h2>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Phone Number</label>
            <input
              type="text"
              placeholder="Enter phone number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
              disabled={lockTime > 0}
            />
          </div>

          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={lockTime > 0}
            />
          </div>

          {errorMsg && <p className="error-text">{errorMsg}</p>}
          {lockTime > 0 && (
            <p className="lock-text">
              Too many failed attempts. Try again in {formatTime(lockTime)}.
            </p>
          )}

          <button
            type="submit"
            className="login-btn"
            disabled={loading || lockTime > 0}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <p className="register-text">
          Don’t have an account? <span>Register here</span>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
